angular.module('gym.reports').factory('EditReportService', ["$rootScope", "$http", function($rootScope, $http) {
  var addColumn, removeColumn, removeUnnecessaryAttributes, toggleDestroyProperty, updateColumnsPosition;
  updateColumnsPosition = function(report) {
    _.each(report.report_columns_attributes, function(column, index) {
      return column.position = index;
    });
    return report;
  };
  removeUnnecessaryAttributes = function(report) {
    report.report_columns_options = void 0;
    report.report_columns_options_keys = void 0;
    report.report_filters_operators = void 0;
    report.rows = void 0;
    return report;
  };
  toggleDestroyProperty = function(report, foundColumn, select) {
    var value;
    value = select || foundColumn._destroy ? '' : 1;
    return report.report_columns_attributes = _.each(report.report_columns_attributes, function(reportColumn) {
      if (foundColumn.unique_id === reportColumn.unique_id) {
        reportColumn._destroy = value;
      }
      return reportColumn;
    });
  };
  removeColumn = function(report, column) {
    return report.report_columns_attributes = _.without(report.report_columns_attributes, column);
  };
  addColumn = function(report, column) {
    return report.report_columns_attributes.push(column);
  };
  return {
    toggleColumn: function(report, column, select) {
      var foundColumn;
      report.report_columns_attributes || (report.report_columns_attributes = []);
      foundColumn = _.findWhere(report.report_columns_attributes, {
        unique_id: column.unique_id
      });
      if (foundColumn && !foundColumn.id && !select) {
        removeColumn(report, foundColumn);
      }
      if (foundColumn != null ? foundColumn.id : void 0) {
        toggleDestroyProperty(report, foundColumn, select);
      }
      if (!foundColumn) {
        addColumn(report, column);
      }
      return report;
    },
    toggleColumns: function(report, columns, select) {
      return columns.forEach((column) => {
        return this.toggleColumn(report, column, select);
      });
    },
    addTag: function(report, tag) {
      report.tag_list || (report.tag_list = []);
      return report.tag_list.push(tag.text);
    },
    removeTag: function(report, tag) {
      return report.tag_list = _.without(report.tag_list, tag.text);
    },
    save: function(report) {
      var url;
      url = `/gyms/${$rootScope.gym.id}/reports`;
      report = updateColumnsPosition(report);
      report = removeUnnecessaryAttributes(report);
      if (report.id) {
        return $http.put(`${url}/${report.id}`, {
          report: report
        });
      } else {
        return $http.post(url, {
          report: report
        });
      }
    }
  };
}]);
